<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 items-center h-[100%] w-[100%]">
    <div
      class="grid grid-rows-2 [border-radius:calc(25px-2vh)] h-[100%] w-[100%] overflow-hidden gap-4"
    >
      <div
        class="flex flex-col w-full h-full bg-white bg-opacity-70 [border-radius:calc(25px-2vh)] overflow-hidden"
      >
        <TypingText class="items-center" />
        <div
          class="h-full w-full pr-8 pl-8 overflow-auto items-center text-justify text-[1.5vh] lg:text-[1vw]"
        >
          Ticaretin her adımında sürecin sorunsuz ilerlemesi için yanınızdayız.
          İthalat, ihracat ve transit tescil işlemlerinden özet beyan, ordino ve
          TIR karnesi hizmetlerine kadar tüm gümrük süreçlerinde profesyonel
          destek sunuyoruz. Evrak hazırlığından idari başvurulara, sahadaki
          operasyonlardan takiplere kadar her aşamada düzenli, dikkatli ve
          güvenilir bir şekilde çalışıyoruz. Amacımız, işlerinizi kolaylaştırmak
          ve süreci sizin için en zahmetsiz hale getirmek.
        </div>
        <div class="flex justify-center items-center">
          <router-link to="/services"
            ><button
              class="my-[4vh] bg-blue-500 text-white font-thin py-2 px-5 rounded-lg shadow-md hover:bg-blue-600 hover:shadow-xl transition-all duration-300 ease-in-out"
            >
              Hizmetlerimiz için tıklayınız
            </button></router-link
          >
        </div>
      </div>
      <video
        autoplay
        loop
        muted
        plays-inline
        class="[border-radius:calc(25px-2vh)] w-full h-full object-cover"
      >
        <source src="@/assets/truck_video.mp4" type="video/mp4" />
      </video>
    </div>
    <div
      class="h-[100%] w-[100%] overflow-hidden relative items-center justify-center lg:flex hidden"
    >
      <div class="group">
        <router-link
          to="/contacts"
          class="relative w-[8vw] h-auto rounded-full p-8 -mt-[13vw] -ml-[10vw] bg-white bg-opacity-70 flex items-center justify-center shadow-2xl hover:animate-salla hover:-mt-[14vw] transition-all duration-300"
          ><img
            :src="abstractPng"
            alt="Abstract Shape"
            class="absolute top-0 w-[8vw] -top-[5vh] -left-[2vw] opacity-0 object-contain group-hover:opacity-50 transition-opacity duration-300" /><svg
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20 4C21.6569 4 23 5.34315 23 7V17C23 18.6569 21.6569 20 20 20H4C2.34315 20 1 18.6569 1 17V7C1 5.34315 2.34315 4 4 4H20ZM19.2529 6H4.74718L11.3804 11.2367C11.7437 11.5236 12.2563 11.5236 12.6197 11.2367L19.2529 6ZM3 7.1688V17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V7.16882L13.8589 12.8065C12.769 13.667 11.231 13.667 10.1411 12.8065L3 7.1688Z"
              fill="#0A5491"
            /></svg
        ></router-link>
      </div>

      <video
        autoplay
        loop
        muted
        plays-inline
        class="w-[25vw] h-[25vw] absolute rounded-full object-cover left-[20vw] shadow-2xl -mt-[10vw] border-8 border-white hover:z-30"
      >
        <source src="@/assets/plane_video.mp4" type="video/mp4" />
      </video>

      <video
        autoplay
        loop
        muted
        plays-inline
        class="w-[25vw] h-[25vw] absolute rounded-full object-cover right-[20vw] mt-[10vw] shadow-2xl border-8 border-white hover:z-30"
      >
        <source src="@/assets/ship_video_1.mp4" type="video/mp4" />
      </video>

      <img
        :src="worldPng"
        alt="World Map"
        class="w-[30vw] h-auto object-contain opacity-100 top-0 left-0 right-0 bottom-0 m-auto absolute mt-[16vw] ml-[13vw] z-[-9]"
      />
    </div>
  </div>
</template>

<script>
import TypingText from '../components/TypingText.vue'
import abstractPng from '../assets/iletisim.png'
import worldPng from '../assets/world.png'
export default {
  name: 'HomeView',
  components: {
    TypingText,
  },
  data() {
    return {
      abstractPng,
      worldPng,
    }
  },
}
</script>
